import { type JSONObject } from '@imago/api-client'
import { type DocBlock } from './_Doc.ts'
import { type EMRKindID, type EMRTypeID } from './_EMR.ts'
import { deserializeUserSurgeryInterestContent, serializeUserSurgeryInterestContent, type UserSurgeryInterestContent, type UserSurgeryInterestContentJSON } from './UserSurgeryInterest.ts'

export const SurgeryRequest_ID = 'imago.user-surgery-request' as EMRTypeID & EMRKindID

export interface UserSurgeryRequestContent {
	quote: UserSurgeryInterestContent
	comments: string
	patient: {
		shortName: string
		pronouns: string
		email: string
		phone: string
	}
}

export interface UserSurgeryRequestContentJSON extends JSONObject {
	quote: UserSurgeryInterestContentJSON
	comments: string
	patient: {
		shortName: string
		pronouns: string
		email: string
		phone: string
	}
}

export function deserializeUserSurgeryRequestContent(userSurgeryRequest: UserSurgeryRequestContentJSON): UserSurgeryRequestContent {
	return {
		...userSurgeryRequest,
		quote: deserializeUserSurgeryInterestContent(userSurgeryRequest.quote),
	}
}

export function serializeUserSurgeryRequestContent(userSurgeryRequest: UserSurgeryRequestContent | undefined | null): UserSurgeryRequestContentJSON | undefined | null {
	return !userSurgeryRequest ? userSurgeryRequest: {
		...userSurgeryRequest,
		quote: serializeUserSurgeryInterestContent(userSurgeryRequest.quote)!,
	}
}

export function docifyUserSurgeryRequest(request: UserSurgeryRequestContent): DocBlock[] {
	const interest = request.quote
	return [
		{ class: 'TITLE', text: "User surgery request" },
		...[...interest.procedures].map(surg => ({ class: 'NORMAL_TEXT', text: `- ${surg}` } satisfies DocBlock)),
		{ class: 'NORMAL_TEXT', text: `Total price: ${interest.totalPrice}` },
		{ class: 'NORMAL_TEXT', text: `When: ${interest.when}` },
		{ class: 'HEADING_1', text: 'Comments' },
		{ class: 'NORMAL_TEXT', text: request.comments },
		{ class: 'HEADING_1', text: 'Patient details' },
		{ class: 'NORMAL_TEXT', text: `Name: ${request.patient.shortName}` },
		{ class: 'NORMAL_TEXT', text: `Pronouns: ${request.patient.pronouns}` },
		{ class: 'NORMAL_TEXT', text: `Email: ${request.patient.email}` },
		{ class: 'NORMAL_TEXT', text: `Phone: ${request.patient.phone}` },
	]
}
